<template>
  <div class="page-route" v-if="showIndex">
    <div class="show-w">
      <label> {{ $t('index') }} </label>
      <template v-for="(item,index) in array">
        <label v-if="!item.url">> {{item.name}} </label>
        <label v-else @click="toUrl(item.url)" class="has-url">> {{item.name}}</label>
      </template>

    </div>
  </div>
</template>

<script>
export default {
  name: 'PageRoute',
  data () {
    return {
      showIndex: false,
      array:[],
      menuArray:this.getArray()
    }
  },
  props:{
    getArray:{
      type:Function,
      default:()=>{
        return [];
      }
    }
  },
  watch:{
    $route(to){
      if(to.path!='/'){
        this.showIndex = true;
        let array = [];
        this.getNowRouteName(to.path,this.menuArray,array);
        this.array = array.reverse();
      }else{
        this.showIndex = false;
      }
    },
    '$i18n.locale'(){
      this.menuArray = this.getArray();
      let array = [];
      this.getNowRouteName(this.$route.path,this.menuArray,array);
      this.array = array.reverse();
    }
  },
  mounted(){
  },
  methods:{
    getNowRouteName(path,list,array){
      for(let i = 0;i<list.length;i++){
        let item = list[i];
        let bol = false;
        if(item.list){
          bol = this.getNowRouteName(path,item.list,array);
        }
        if(bol){
          array.push(item);
          return true;
        }
        if(item.url&&item.url==path){
          array.push(item);
          return true;
        }
      }
    },
    toUrl(url){
      this.$router.push({path:url,query:{t:Date.now()}});
    }
  }
}
</script>

<style scoped>
  .page-route{
    margin: 38px 0 32px 0;
    font-size: 14px;
    line-height: 20px;
    color: #4A4A4A;
  }
  .has-url{
    color: #FF722F;
    cursor: pointer;
  }
  .has-url:hover{
    color: #FF925E;
  }
</style>



// WEBPACK FOOTER //
// src/components/PageRoute.vue